import styled from '@emotion/styled';
import { TableCell } from './TableCell';

export const TableCaptionCell = styled(TableCell)`
  padding: 10px 0;
`;
